import { AuthContext } from 'auth/context/AuthContext';
import { useContext,useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button,Card,Form,Container,Row, Col } from "react-bootstrap";
import { MensajeAlerta} from '../components/Messages/MensajeAlerta';
import logo from "assets/img/logothvertical.png"
import React from "react";
export const Recuperar = () => {
    let valoresLogin={
        UsuarioOCorreo:''
    }
    const [imageLogo, setImage] = React.useState(logo);
    const navigate = useNavigate();
    const {recuperar}=useContext(AuthContext)
    const [valorLogin, setValoresLogin] = useState(valoresLogin);
    let mensajesAlerta={
        mensaje:'',
        estado:0
    }
    const [mensajeAlerta, setMensaje] = useState(mensajesAlerta);
    const onSend = async(event) => {
        event.preventDefault();
        const resp=await recuperar(valorLogin);
        setMensaje({mensaje:resp.message,estado:resp.success})
    }
    const onCambio=(event)=>{
        setValoresLogin({ ...valorLogin, [event.target.name]: event.target.value });
    }
    const onBack = () => {
        navigate('/login', {
            replace: true
        });
    }
    return (
        <>
          <div className="wrapper" style={{ backgroundColor: "#444444" }}>
            <Container fluid>
              {/* Alto completo y centrado */}
              <Row className="min-vh-100 py-5 d-flex align-items-center justify-content-center">
                {/* Columna responsiva para el card */}
                <Col xs={12} sm={10} md={6} lg={4}>
                  <Card className="shadow-sm">
                    <Card.Header className="bg-white">
                      <div className="logo d-flex justify-content-center">
                        <a href="#" className="simple-text logo-mini mx-1">
                          <img
                            src={imageLogo}
                            alt="Logo"
                            style={{ maxWidth: "220px", width: "100%", height: "auto" }}
                          />
                        </a>
                      </div>
                    </Card.Header>
      
                    <Card.Body className="p-3 p-md-4">
                      <Form onSubmit={(e) => e.preventDefault()}>
                        <Row className="g-3">
                          <Col xs={12}>
                            <Form.Group controlId="recoverUsuarioOCorreo">
                              <Form.Label>Usuario para recuperar contraseña</Form.Label>
                              <Form.Control
                                name="UsuarioOCorreo"
                                type="text"
                                placeholder=""
                                defaultValue={valoresLogin?.UsuarioOCorreo}
                                onChange={onCambio}
                                autoComplete="username email"
                                inputMode="email"
                              />
                            </Form.Group>
                          </Col>
      
                          <Col xs={12}>
                            {/* Botonera: apilada en móvil; derecha en md+ */}
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                              <Button
                                type="button"
                                variant="outline-light"
                                className="btn btn-primary"
                                onClick={onBack}
                              >
                                Volver
                              </Button>
                              <Button
                                type="button"
                                variant="primary"
                                className="btn btn-primary"
                                onClick={onSend}
                              >
                                Enviar
                              </Button>
                            </div>
                          </Col>
      
                          <Col xs={12}>
                            <MensajeAlerta
                              mensajeTexto={mensajeAlerta.mensaje}
                              estado={mensajeAlerta.estado}
                            />
                          </Col>
                        </Row>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      );
      
}
export default Recuperar;
